import { useEffect, type RefObject } from 'react'

export function useContextMenuClose(
  menuRef: RefObject<HTMLDivElement | null>,
  onClose: () => void
): void {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose()
      }
    }
    const handleEscape = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [menuRef, onClose])
}

interface MenuPosition {
  x: number
  y: number
  widthPx: number
  heightPx: number
}

export function clampMenuPosition({ x, y, widthPx, heightPx }: MenuPosition): {
  left: number
  top: number
} {
  return {
    left: Math.min(x, window.innerWidth - widthPx),
    top: Math.min(y, window.innerHeight - heightPx),
  }
}
